import { IDataFileVisitor } from './IDataFileVisitor.js';
import {
  Doc,
  DocCompatibilityTable,
  DocExternalField,
  DocJsFilter,
  DocOclConstraint,
  DocOclFilter,
  DocOption,
  DocOptionGroup,
  DocProduct,
  DocProductGroup
} from './DataFile.js';

export class CompositeDataFileVisitor implements IDataFileVisitor {
  readonly visitors: IDataFileVisitor[];

  constructor(...visitors: IDataFileVisitor[]) {
    this.visitors = visitors;
  }

  visitUnknown(doc: Doc): void {
    this.visitors.forEach(visitor => visitor.visitUnknown(doc));
  }

  visitCompatibilityTable(doc: DocCompatibilityTable): void {
    this.visitors.forEach(visitor => visitor.visitCompatibilityTable(doc));
  }

  visitExternalFiled(doc: DocExternalField): void {
    this.visitors.forEach(visitor => visitor.visitExternalFiled(doc));
  }

  visitJsFilter(doc: DocJsFilter): void {
    this.visitors.forEach(visitor => visitor.visitJsFilter(doc));
  }

  visitOclConstraint(doc: DocOclConstraint): void {
    this.visitors.forEach(visitor => visitor.visitOclConstraint(doc));
  }

  visitOclFilter(doc: DocOclFilter): void {
    this.visitors.forEach(visitor => visitor.visitOclFilter(doc));
  }

  visitOption(doc: DocOption): void {
    this.visitors.forEach(visitor => visitor.visitOption(doc));
  }

  visitOptionGroup(doc: DocOptionGroup): void {
    this.visitors.forEach(visitor => visitor.visitOptionGroup(doc));
  }

  visitProduct(doc: DocProduct): void {
    this.visitors.forEach(visitor => visitor.visitProduct(doc));
  }

  visitProductGroup(doc: DocProductGroup): void {
    this.visitors.forEach(visitor => visitor.visitProductGroup(doc));
  }

  beforeAll(): void {
    this.visitors.forEach(visitor => visitor.beforeAll());
  }

  afterAll(): void {
    this.visitors.forEach(visitor => visitor.afterAll());
  }
}
